/* tslint:disable */
/* eslint-disable */
/**
 * File API
 * API for managing files
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentUrlDto } from './DocumentUrlDto';
import {
    DocumentUrlDtoFromJSON,
    DocumentUrlDtoFromJSONTyped,
    DocumentUrlDtoToJSON,
    DocumentUrlDtoToJSONTyped,
} from './DocumentUrlDto';

/**
 * 
 * @export
 * @interface DocumentsUrlResponse
 */
export interface DocumentsUrlResponse {
    /**
     * List of document URLs
     * @type {Array<DocumentUrlDto>}
     * @memberof DocumentsUrlResponse
     */
    urls?: Array<DocumentUrlDto>;
}

/**
 * Check if a given object implements the DocumentsUrlResponse interface.
 */
export function instanceOfDocumentsUrlResponse(value: object): value is DocumentsUrlResponse {
    return true;
}

export function DocumentsUrlResponseFromJSON(json: any): DocumentsUrlResponse {
    return DocumentsUrlResponseFromJSONTyped(json, false);
}

export function DocumentsUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentsUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'urls': json['urls'] == null ? undefined : ((json['urls'] as Array<any>).map(DocumentUrlDtoFromJSON)),
    };
}

export function DocumentsUrlResponseToJSON(json: any): DocumentsUrlResponse {
    return DocumentsUrlResponseToJSONTyped(json, false);
}

export function DocumentsUrlResponseToJSONTyped(value?: DocumentsUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'urls': value['urls'] == null ? undefined : ((value['urls'] as Array<any>).map(DocumentUrlDtoToJSON)),
    };
}

